export interface Pagination {
  page: number;
  size: number;
}

export const defaultPagination: Pagination = {
  page: 0,
  size: 10,
};

export interface PaginatedResponse<T> {
  content?: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  sort: string;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export const defaultPaginatedResponse: PaginatedResponse<any> = {
  totalElements: 0,
  totalPages: 0,
  size: 0,
  number: 0,
  sort: "",
  numberOfElements: 0,
  first: false,
  last: false,
  empty: true,
};
